import Router from "./router";
import { RoleProvider } from "@hooks/useRole";
import AppProviders from "@wrappers/wrapper.root";
import 'bootstrap/dist/css/bootstrap-utilities.min.css'
import "./global.scss";
import { useEffect } from 'react';


export default function App() {

   useEffect(() => {
    window.handleAndroidBack = () => {
      if (window.history.length > 1) {
        window.history.back();
      } else {
        if (window.Android?.closeApp) {
          window.Android.closeApp();
        }
      }
    };

    return () => {
      delete window.handleAndroidBack;
    };
  }, []);
  return (<>    
   <AppProviders>
       <RoleProvider>
        <Router />
      </RoleProvider>
    </AppProviders>
    </>
  );
}
